import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'atsBool',
    standalone: false
})
export class AtsBooleanPipe implements PipeTransform {
	public positive = 'Yes';
	public negative = 'No';
	public unavailable = 'N/A';
	constructor() {}

	transform(value?: boolean | string, binary = true): string {
		return binary || value !== null ? (!value || value === '' ? this.negative : this.positive) : this.unavailable;
	}

	public isTrue(val: boolean | string) {
		return !this.isFalsey(val);
	}

	public isTruthy(val: boolean | string) {
		return this.isTrue(val);
	}

	public isFalse(val: boolean | string) {
		return (
			val === false ||
			val === '' ||
			val.toString().toLowerCase() === this.negative.toLowerCase() ||
			val.toString().toLowerCase() === 'false'
		);
	}

	public isNull(val: boolean | string) {
		return val === null || val === this.unavailable;
	}

	public isFalsey(val: boolean | string) {
		return this.isFalse(val) || this.isNull(val);
	}
}
